import { RouterProvider, createRouter } from "@tanstack/react-router";
import { useAuth } from "react-oidc-context";
import { Loader2 } from "lucide-react";

import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function Router() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="w-full flex flex-row justify-center mt-8">
        <Loader2 className="animate-spin" />
      </div>
    );
  }

  return <RouterProvider router={router} context={{ auth: auth }} />;
}
